<eventq-action-loader [message]="message" />

@if (startConflict(); as conflict) {
  <eventq-dialog-popover
    [open]="true"
    [title]="conflict.kind === 'queue' ? 'Site is actively alarming' : 'Site in use'"
    [cancelLabel]="conflict.kind === 'queue' ? 'Cancel and Ignore' : 'Close'"
    confirmLabel="Yes, Process Event"
    [showConfirm]="conflict.kind === 'queue'"
    placement="center"
    panelWidth="32rem"
    (closed)="onConflictDismiss()"
    (confirmed)="onConflictConfirm()"
  >
    <div class="patrol-start-conflict">
      @if (conflict.kind === 'queue') {
        <svg class="patrol-start-conflict__icon patrol-start-conflict__icon--alarm" viewBox="0 0 48 48" aria-hidden="true">
          <path
            fill="currentColor"
            d="M24 4 8 10v12c0 9.2 6.4 17.8 16 20 9.6-2.2 16-10.8 16-20V10L24 4Z"
          />
          <path
            fill="#1a1a1a"
            d="M24 16a3 3 0 0 0-3 3v5.2l-.8 2.3a1.6 1.6 0 0 0 1.5 2.1h4.6a1.6 1.6 0 0 0 1.5-2.1L27 24.2V19a3 3 0 0 0-3-3Zm0 14.2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
          />
        </svg>
        <div class="patrol-start-conflict__copy">
          <p>Active alarm on site. Manual Patrol/Site Check unavailable until claimed.</p>
          <p class="patrol-start-conflict__question">Process the event now?</p>
        </div>
      } @else {
        <svg class="patrol-start-conflict__icon patrol-start-conflict__icon--claimed" viewBox="0 0 48 48" aria-hidden="true">
          <path
            fill="currentColor"
            d="M24 4 8 10v12c0 9.2 6.4 17.8 16 20 9.6-2.2 16-10.8 16-20V10L24 4Z"
          />
          <path
            fill="none"
            stroke="#1a1a1a"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m16.5 24.5 5 5 10-11"
          />
        </svg>
        <p class="patrol-start-conflict__copy">
          Site already claimed. Manual Patrol/Site Check unavailable while in use.
        </p>
      }
    </div>
  </eventq-dialog-popover>
}
